import { useMemo } from "react";
import { useCompletedJobs } from "./use-report-data";
import { DateValue } from "~/shared/lib/analytics-utils";

/** One row of «Покрытие вывоза фотоматериалом» (AIS 15.2.1): a driver's completed jobs with a photo. */
export interface PhotoCoverageRow {
  driverId: bigint;
  driverName: string;
  serviceProviderName: string;
  withPhoto: number;
  total: number;
}

/** Completed jobs of the period per driver; jobs without a driver are left out. */
export function usePhotoCoverageRows(startDate: DateValue, endDate: DateValue) {
  const { rows: jobs, isLoading, error } = useCompletedJobs(startDate, endDate);

  const rows = useMemo<PhotoCoverageRow[]>(() => {
    const byDriver = new Map<string, PhotoCoverageRow>();
    for (const job of jobs) {
      if (!job.driverId) continue;
      const key = String(job.driverId);
      let row = byDriver.get(key);
      if (!row) {
        row = {
          driverId: job.driverId,
          driverName: job.driverName ?? "",
          serviceProviderName: job.serviceProviderName ?? "",
          withPhoto: 0,
          total: 0,
        };
        byDriver.set(key, row);
      }
      row.total += 1;
      if (job.hasPhotoReport) row.withPhoto += 1;
    }
    return [...byDriver.values()].sort((a, b) => a.driverName.localeCompare(b.driverName));
  }, [jobs]);

  return { rows, isLoading, error };
}
